import React from "react"
import { Plane, HelpCircle } from "lucide-react"
import PlaneImg from "../../../../../assets/avia/ticket/plane_white.png"
import { useTranslation } from "react-i18next"
// import LuggaeIcn from "../../../../../assets/avia/ticket/loggage.svg"
// import SecondLuggaeIcn from "../../../../../assets/avia/ticket/secondluggage.svg"
// import HandbagIcn from "../../../../../assets/avia/ticket/handbag.svg"
// import BulletPointIcn from "../../../../../assets/avia/ticket/bullet-point.svg"

const FlightCard = ({ cardData, isRoundTrip }) => {
  const { t } = useTranslation()
  //
  const { type, from, to, time, duration, airline, classSeat, isDirect, isNight, details } =
    cardData

  return (
    <div className="w-full  md:min-w-[600px] ">
      {/* Header */}
      <div className="flex items-center gap-4 mb-3 px-3">
        <div className="flex items-center justify-start gap-1 bg-gradient-to-r from-second-success to-success text-white px-2 py-0.5 rounded-full w-fit">
          <img className="w-[27px] rotate-90 h-[27px] shrink-0" src={PlaneImg} alt="plane img" />
          <span className="font-semibold text-sm sm:text-lg">
            {isRoundTrip
              ? type === "departure"
                ? t("admin.there")
                : t("admin.back2")
              : t("admin.one_way_ticket_v3")}
          </span>
        </div>

        <div className="text-base sm:text-lg font-semibold text-dark-gray">
          {from.city} — {to.city}
        </div>

        <div className="text-light-gray text-sm sm:text-base">{duration}</div>
      </div>

      <div className="bg-white px-3 py-2 rounded-2xl shadow-md">
        <div className="flex gap-4">
          <div className="flex gap-4">
            <div className="flex flex-col justify-between items-center">
              <div className="text-base sm:text-[28px] font-bold text-dark-gray">
                {time.departure}
              </div>
              <div className="text-base sm:text-[28px] font-bold text-dark-gray">
                {time.arrival}
              </div>
            </div>
            <div className="flex items-center flex-col justify-between h-full">
              <div className="hidden lg:flex flex-col items-center h-full">
                <div className="w-3 h-3 bg-second-success rounded-full my-2" />
                <div className="w-0.5 flex-1 bg-second-success" />
                <div className="w-3 h-3 bg-second-success rounded-full my-2" />
              </div>
              <div className="lg:hidden flex items-center w-full mx-2">
                <div className="h-0.5 flex-1 bg-blue-400" />
              </div>
            </div>
          </div>

          <div className="flex-1 space-y-2">
            <div>
              <div className="text-lg sm:text-xl font-semibold text-text-main">{from.city}</div>
              <div className="text-text-secondary text-sm">{from.code}</div>

              <div className="text-text-secondary font-normal my-3">
                {t("admin.flight_duration")} {duration}
              </div>

              <div className="space-y-1 text-sm">
                <div>
                  {t("admin.route_lower")}{" "}
                  <span className="font-semibold">{details?.flightNumber}</span>
                </div>
                {/* <div className="text-dark-gray">{classSeat}</div> */}

                {airline && (
                  <div className="flex flex-nowrap items-center gap-2 mt-2">
                    <img className="w-7 h-5" src={details?.airlineImg} alt={airline} />
                    <span>
                      {t("admin.performed_by_airline")}{" "}
                      <span className="text-dark-red font-semibold">{airline}</span>
                    </span>
                  </div>
                )}
              </div>
            </div>

            <div>
              <div className="text-base font-semibold text-text-main">{to.city}</div>
              <div className="text-text-secondary text-sm">{to.code}</div>
            </div>
          </div>
          {/* 
          <div className="">
            <div className="text-lg font-semibold text-gray-800 mb-4">Багаж</div>

            <div className="space-y-1 text-sm">
              {[
                {
                  color: "text-dark-green",
                  label: `${t("admin.personal_item")} 1PC`,
                  icon: HandbagIcn,
                },
                { color: "text-dark-red", label: t("admin.hand_luggage"), icon: LuggaeIcn },
                {
                  color: "text-dark-red",
                  label: t("admin.personal_item"),
                  icon: SecondLuggaeIcn,
                },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-1">
                  <img src={item.icon} alt={item.label} />
                  <div className="flex items-center gap-0.5">
                    <span>{item.label}</span>
                    <div className="rounded-full flex items-center justify-center bg-white shadow-lg w-[17px] h-[17px]">
                      <HelpCircle className={`${item.color} w-[15px] h-[15px]`} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default FlightCard
